export const getASIntegratorTemplateScriptSrc = (): string => {
  return "https://storage.googleapis.com/sb-ui/springboard.esm.js";
};